import { useState } from "react";
import HeaderMenu from "./components/HeaderMenu/HeaderMenu";
import styles from "./Header.module.scss";
import pokeball from "./../../assets/images/pokeball_icon.png";
import { NavLink } from "react-router-dom";
import SearchBar from "./components/SearchBar/SearchBar";
import pokedex from "./../../assets/images/pokedex.png";

function Header() {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <header className={`${styles.header} d-flex flex-row align-items-center`}>
      <div className="flex-fill">
        <div
          className={`${styles.logo} d-flex flex-row align-items-center mr-5`}
        >
          <img className="mr-5" src={pokedex} alt="Pokeball" />
          <span>PokedeXpert</span>
        </div>
      </div>
      <ul className={`${styles.headerList} d-flex flex-row align-items-center`}>
        <SearchBar />
        <NavLink to="/">
          <button
            key="btnPokemons"
            className="mr-5 btn btn-transparent d-flex align-items-center"
          >
            <img className="mr-5" src={pokeball} alt="" />
            <span>Pokemons</span>
          </button>
        </NavLink>
      </ul>
      <i
        onClick={() => setShowMenu(true)}
        className={`fa-solid fa-bars mr-15 ${styles.headerXs}`}
      ></i>
      {showMenu && (
        <>
          <div onClick={() => setShowMenu(false)} className="calc"></div>
          <HeaderMenu />
        </>
      )}
    </header>
  );
}

export default Header;
